<template>
  <section class="fmhind-tab-general">
    <div class="fmhind-tab-general__column">
      <Sectors class="fmhind-tab-general__chart" />
      <GeneralAndSpecialistDoctors class="fmhind-tab-general__chart" />
    </div>
  </section>
</template>

<script>
import Sectors from '@/components/ConcreteCharts/Sectors';
import GeneralAndSpecialistDoctors from '@/components/ConcreteCharts/GeneralAndSpecialistDoctors';

export default {
  name: 'General',
  components: {
    Sectors,
    GeneralAndSpecialistDoctors
  }
};
</script>

<style lang="scss">
.fmhind-tab-general__column {
  box-sizing: border-box;
  width: 100%;
  //width: 59.5%;
  //margin-right: 1%;
  @include media('<medium') {
    width: 100% !important;
    margin-right: 0;
    padding: $padding-lg;
  }
}

.fmhind-tab-general__chart {
  &:first-child {
    @include media('>medium') {
      padding: 0;
    }
  }

  &:nth-child(1) {
    padding: $padding-lg + $padding-md;
    margin-bottom: $unit * 2;
    background: $color-bg-1;
  }

  &:nth-child(2) {
    width: 70%;

    @include media('<small') {
      width: 100%;
    }
  }
}
</style>
